import { ReactNode } from "react";

import Divider from "@vfuk/core-divider";
import SearchInput from "@vfuk/core-search-input";

import classes from "./TableControls.module.scss";

type TableControlsProps = {
  id: string;
  search?: {
    placeholder: string;
    value: string;
    valueChanged: (value: string) => void;
    onSubmit?: () => void;
    disabled?: boolean;
  };
  customComponent?: ReactNode;
  filterButton?: ReactNode;
  deleteButton?: ReactNode;
  addButton?: ReactNode;
  children?: ReactNode;
};

export const TableControls = ({
  id,
  search,
  customComponent,
  deleteButton,
  filterButton,
  addButton,
}: TableControlsProps): JSX.Element => {
  return (
    <div className={classes.Controls}>
      {filterButton && <div className={classes.Filter}>{filterButton}</div>}
      {search && (
        <div className={classes.Search}>
          <SearchInput
            textInput={{
              id: `${id}-search`,
              placeholder: search.placeholder,
              value: search.value,
              onChange: (e) => {
                search.valueChanged(e.target.value);
              },
            }}
            fieldWrapper={{
              label: search.placeholder,
              showLabel: false,
            }}
            onClear={() => search.valueChanged("")}
            state={search.disabled ? "disabled" : undefined}
            searchIconButton={{
              onClick: search.onSubmit
                ? search.onSubmit
                : () => {
                    return;
                  },
            }}
          />
        </div>
      )}
      {customComponent && customComponent}

      <div className={classes.RightAlignedItems}>
        {deleteButton && <div className={classes.Remove}>{deleteButton}</div>}
        {deleteButton && addButton && (
          <Divider appearance="secondary" orientation="vertical" />
        )}
        {addButton && <div className={classes.Add}>{addButton}</div>}
      </div>
    </div>
  );
};
